<rk-form-field [label]="label">
  <div class="main relative w-full md:w-auto">
    <input
      class="w-full md:w-[150px]"
      data-cy="input-color-field"
      type="text"
      #inputRef
      [disabled]="disabled"
      [(colorPicker)]="color"
      [cpPosition]="'bottom'"
      [cpAlphaChannel]="'disabled'"
      [cpOutputFormat]="'hex'"
      (colorPickerChange)="writeValue(color)"
      [value]="color"
    />
    <div
      class="color-preview w-7 h-7 md:w-5 md:h-5 right-2"
      [class.white]="color === '#FFFFFF'"
      (click)="focusInput()"
      [style.background]="color"
    ></div>
    <ng-content select="rk-form-error"></ng-content>
  </div>
</rk-form-field>

<div class="presets">
  <div
    *ngFor="let colors of getColors()"
    class="sample-color w-10 h-10 md:w-5 md:h-5"
    [class.selected]="color === colors"
    [class.white]="colors === '#FFFFFF'"
    (click)="writeValue(colors)"
    [style.background]="colors"
    data-cy="input-color-preset"
  >
    <mat-icon fontSet="fas" fontIcon="fa-check"></mat-icon>
  </div>
</div>
